module.exports = __webpack_public_path__ + "img/lb4.98f3fff7.jpg";